module.exports = __webpack_public_path__ + "static/media/BuildingStorey.7da4215b.svg";